import {historySvg as Icon__small__historySvg} from '../Icon__small/Icon__small--history.js';
import {historySvg as Icon__xsmall__historySvg} from '../Icon__xsmall/Icon__xsmall--history.js';

export var history = {
  name: 'history',
  category: 'icon',
  colorable: true,
  svg: Icon__small__historySvg,
  alt: {
    Icon__small: Icon__small__historySvg,
    Icon__xsmall: Icon__xsmall__historySvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
